import { getProduct, getProductByProductID } from "./products";

//—— 顧客評價 ——
//
//  首頁與 /reviews 共用這一份（首頁只取前五則）。原本放在 home-content，
//  但它已經不只是首頁的內容了 —— 放在那裡會變成「評價頁去 import 首頁」。
//
//  評語取自各產品故事頁的「真實用戶回饋」（baiye-story / jingyue-story /
//  feihong-story 的 reviews 區塊）—— 兩邊講的要是同一批人、同一種語氣，
//  不然首頁說的和故事頁說的像兩家公司。
//
//  伏爻子沒有故事頁，那三則是新寫的，但講的事都對得上他實際交付的東西
//  （engines/wenwang-hexagram：不收生辰、卦象與爻辭、零術語的白話段、
//  以及「不替人下決定」那條性格設定）。
//
//  這一份現在是**備援**，不是主要來源 —— 真實評價走 hooks/useReviews，
//  只有在上架的則數還不到 MIN_REAL_REVIEWS 時才退回這裡。
//  信箱已在後端遮蔽（只留前兩碼），前端不做二次處理。

//評價卡要指向的產品摘要。
//  卡片有一條「這則評價在講哪支產品」的連結，它讀的是 product.path。
//
//  ⚠️ 原本是手寫的物件（九尾狐八字、明星合盤、流年之書、職業八字），
//  兩個問題：那四支產品不存在，而且沒有 path，所以那條連結一律跳 "#"
//  （review-card.js 寫的是 to={product.path || "#"}）。
const summarize = (p) => {
  if (!p) return null;

  return {
    code: p.code,
    glyph: p.glyph,
    theme: p.theme,
    title: p.title,
    subtitle: p.subtitle,
    path: p.path,
  };
};

//  備援資料用：吃前端的產品代號（bazi-baiye 這種）
export const toReviewProduct = (code) => summarize(getProduct(code));

//  真實評價用：吃後端訂單上的 productID（baiye / gua-6 這種）。
//  ⚠️ 兩套代號不一樣，對照表在 constant/products 的 CODE_BY_PRODUCT_ID。
export const toReviewCardProduct = (productID) =>
  summarize(getProductByProductID(productID));

//—— 一則評語最多四行 ——
//  卡片是 truncate(4)（見 review-card-style），超過會被切在句子中間。
//  欄寬 440 扣掉 container 與卡片內距之後，15px 的字一行大約 24 個中文字,
//  而 \n 會強制斷行 —— 所以「行數」要算的是「每一段各自折幾行」的總和。
//  故事頁那邊一則可以攤開四五行，搬過來時刪的是末句，不是中間。
export const REVIEWS = [
  {
    id: "rv-1",
    email: "aj****@gmail.com",
    rating: 5,
    repeatCount: 0,
    timeAgo: "9 小時前",
    content:
      "超準＝＝剛看第一頁我就毛骨悚然\n連我從小到大的隱密脾氣都被點出來 太扯了！",
    product: toReviewProduct("bazi-baiye"),
  },
  {
    id: "rv-2",
    email: "cl*****@gmail.com",
    rating: 5,
    repeatCount: 0,
    timeAgo: "1 天前",
    content:
      "原本以為只是普通的紫微測算，結果大限解析那段\n精準講中我前年換工作跟失戀的時間點\n內容超級豐富，完全不是那種套公式的罐頭文字",
    product: toReviewProduct("ziwei-jingyue"),
  },
  {
    id: "rv-3",
    email: "an*****@hotmail.com",
    rating: 5,
    //測過兩個對象。合盤是五支裡最容易回購的一支 —— 換一個人就要再測一次。
    repeatCount: 2,
    timeAgo: "2 天前",
    content:
      "測完發現花這個錢超值！\n把我們兩個八字互相吸引又互相猜忌的原因講得超精準\n連對方骨子裡的防禦機制都說中了\n直接省下我猜心意的時間！！！",
    product: toReviewProduct("match-feihong"),
  },
  {
    id: "rv-4",
    email: "yu****@gmail.com",
    rating: 5,
    //他是五支裡回購最高的一支（單價最低、一有事就想再問一次，
    //  見 products.js 的定價說明）—— 那正是這張卡要傳達的事。
    repeatCount: 4,
    timeAgo: "3 天前",
    content:
      "不用生日不用填一堆 直接問就給卦\n上面爻辭那段看不懂沒關係 下面白話的講得超清楚\n我已經問第四次了 真的有事就想來問一下 😂",
    product: toReviewProduct("liuyao-fuyaozi"),
  },
  {
    id: "rv-5",
    email: "81******@gmail.com",
    rating: 5,
    repeatCount: 0,
    timeAgo: "4 天前",
    content:
      "之前買過別家的都很籠統 這家的報告超級具體 講中我去年事業的大坑",
    product: toReviewProduct("bazi-baiye"),
  },
  {
    id: "rv-6",
    email: "ty******@gmail.com",
    rating: 5,
    repeatCount: 0,
    timeAgo: "5 天前",
    content:
      "講中我今年紫微化忌的破財危機🤣🤣🤣\n看完報告立刻調整投資策略 直接幫我避開一個大坑 這錢根本花得太划算了！",
    product: toReviewProduct("ziwei-jingyue"),
  },
  {
    id: "rv-7",
    email: "ke****@gmail.com",
    rating: 5,
    repeatCount: 0,
    timeAgo: "6 天前",
    content:
      "跟對象卡在曖昧期快半年，進退兩難快被逼瘋\n緋紅把對方忽冷忽熱的背後心態拆解得一清二楚\n照著建議調整態度，隔天對方竟然主動約我了",
    product: toReviewProduct("match-feihong"),
  },
  {
    id: "rv-8",
    email: "gr*****@gmail.com",
    rating: 5,
    repeatCount: 0,
    timeAgo: "1 週前",
    content: "很多沒跟任何人講過的私事全部被寫出來\n看完直接起雞皮疙瘩 😱😱",
    product: toReviewProduct("bazi-baiye"),
  },
  {
    id: "rv-9",
    email: "hs****@gmail.com",
    rating: 5,
    repeatCount: 2,
    timeAgo: "1 週前",
    //「不會幫你決定」對應 ROLE 裡那句「你看得透，卻不替人下決定」——
    //  那是他跟其他四位最不一樣的地方，值得有人替他講出來。
    content:
      "卡在要不要辭職 問了兩次\n第一次的卦講的跟第二次一樣 反而讓我下定決心\n老先生不會幫你決定 但會把話講得很清楚",
    product: toReviewProduct("liuyao-fuyaozi"),
  },
  {
    id: "rv-10",
    email: "b0******@gmail.com",
    rating: 5,
    repeatCount: 0,
    timeAgo: "1 週前",
    content:
      "本來抱著試試看的心態 結果看完直接掉眼淚\n報告裡不只準 還給了很具體的破局建議 感覺整個人被理解了",
    product: toReviewProduct("ziwei-jingyue"),
  },
  {
    id: "rv-11",
    email: "cy*****@yahoo.com.tw",
    rating: 5,
    repeatCount: 0,
    timeAgo: "2 週前",
    content:
      "原本以為結婚後測這個沒意思，結果關於兩人家運流轉和未來幾年的感情考驗很有參考價值👍\n語氣既像妖魅調侃又像長輩寵溺，閱讀體驗極佳！",
    product: toReviewProduct("match-feihong"),
  },
  {
    id: "rv-12",
    email: "03*********@gmail.com",
    rating: 4,
    repeatCount: 0,
    timeAgo: "2 週前",
    content: "原本只是隨便測測看\n結果連我最近在糾結的事都說中了…",
    product: toReviewProduct("bazi-baiye"),
  },
  {
    id: "rv-13",
    email: "pi*****@yahoo.com.tw",
    rating: 4,
    repeatCount: 0,
    timeAgo: "2 週前",
    //刻意留一則四星、而且是有抱怨的 —— 十五則全是五星沒有一句不滿意，
    //  讀起來像自己寫的。而這個抱怨是真的（terms 那段本來就是寫給
    //  看得懂術語的人看的），不是為了裝樣子編一個假缺點。
    content:
      "問事業的，卦象那段我看不懂\n但白話跟建議寫得很實在 沒有講一堆模稜兩可的話",
    product: toReviewProduct("liuyao-fuyaozi"),
  },
  {
    id: "rv-14",
    email: "er*******@gmail.com",
    rating: 5,
    repeatCount: 0,
    timeAgo: "3 週前",
    content:
      "太神了啦！\n直接點我為什麼一直被小人絆住💢\n照著報告裡的建議調整之後 這個月職場運勢真的明顯變順！",
    product: toReviewProduct("ziwei-jingyue"),
  },
  {
    id: "rv-15",
    email: "pe*****@gmail.com",
    rating: 5,
    repeatCount: 0,
    timeAgo: "3 週前",
    content:
      "這絕對是我買過最精細的感情八字報告\n讀完我和男友開誠布公聊了一整晚\n感情反而變更好了！",
    product: toReviewProduct("match-feihong"),
  },
];

//首頁那一區只放幾則。
//  五則剛好讓四支產品都露臉一次，再多就把下面的頁尾推得太遠 ——
//  想看更多的人會按「看更多」，那才是評價頁存在的理由。
export const HOME_REVIEW_COUNT = 5;

//—— 要湊到幾則才切換成真實評價 ——
//
//  不是「有一則就換」：真實評價只有兩三則的時候，/reviews 整頁只有兩張卡、
//  篩選列只有一個分頁，比備援那十五則更不可信 —— 看起來像沒人買過。
//
//  也不混著放。混的話同一頁會同時出現「9 小時前」（寫死的）跟真實時間，
//  而且備援那幾則的 repeatCount 全是 0 —— 一眼就看得出兩批資料不同源。
//
//  八則：首頁取五則還剩三則給「看更多」，而且至少會有兩三支產品露臉。
//  ⚠️ 這個數字是我挑的，不是算出來的。要調就改這裡一個數。
export const MIN_REAL_REVIEWS = 8;

//  星等門檻刻意不做 —— 上不上架是後台一則一則按的（models/review 的
//  published 預設 false）。在這裡再加一道「幾顆星以下不顯示」會變成
//  「後台按了上架但前台不顯示」，那種不一致沒人查得出來。
